import type { FaireProductEntity } from "../../entity_types/product";

export const p_ts4fr63ear: FaireProductEntity = {
  token: "p_ts4fr63ear",
  type: "product",
  name: "Hawaii Island Postcards",
  brandName: "Lauren Roth Art",
  imageUrl:
    "https://cdn.faire.com/fastly/24d5ff627d7a81f0a863470ec786fe7e29629cd850be77a2d41365827c0950b4.jpeg",
  priceDollars: 2.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/6b666c78c0a1c290c23454cb7a0c1a5efd63d20ca3f16132056a0094501cdfc1.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
